import { render, staticRenderFns } from "./CompanyLimit.vue?vue&type=template&id=7d210c5a&"
import script from "./CompanyLimit.vue?vue&type=script&lang=js&"
export * from "./CompanyLimit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports